import { cn } from 'support/helpers/cn/cn';

type InputLabelProps = {
  label?: string;
  variant?: 'default' | 'large' | 'field';
  required?: boolean;
  htmlFor?: string;
};

const LABEL_CLASSNAME_BY_VARIANT: Record<NonNullable<InputLabelProps['variant']>, string> = {
  default: 'text-sm text-gray-500',
  large: 'text-base font-semibold text-gray-900',
  field: 'text-sm font-medium text-gray-700',
};

export const InputLabel = ({ label, variant = 'default', required, htmlFor }: InputLabelProps) => {
  if (!label) {
    return null;
  }

  const labelClassName = LABEL_CLASSNAME_BY_VARIANT[variant];

  return (
    <label className={cn('block text-wrap', labelClassName)} htmlFor={htmlFor}>
      {label}
      {Boolean(required) && <span className="text-procuros-green-600"> *</span>}
    </label>
  );
};
